import { Component, OnDestroy, OnInit } from '@angular/core';
import { TenantService } from '../../../services/tenant.service'
import { SubscriptionService } from 'src/services/subscription.service';
import { UserService } from 'src/services/user.service';
import { combineLatest, firstValueFrom, Subscription } from 'rxjs';
import { FormBuilder, FormControl, FormGroup, Validators  } from '@angular/forms';
import { ActivatedRoute, ParamMap } from '@angular/router';

@Component({
  selector: 'app-activated',
  templateUrl: './activated.component.html',
  styleUrls: ['./activated.component.css']
})
export class ActivatedComponent implements OnInit, OnDestroy {
  
  loading: boolean = true;
  PlanType: string = '';
  PlanSize: string = '';
  PlanID: string = '';
  ExpiryDate: Date = new Date();
  tenants: any = [];
  tenantsLoaded: boolean = false;


  constructor (
    private formBuilder: FormBuilder,
    private TenantService: TenantService,
    private SubscriptionService: SubscriptionService,
    private userService: UserService,
    private route: ActivatedRoute){
    }
  
  subscriptions: any[] = [];
  activatedFormGroup: FormGroup;
  token: any;

  ngOnInit() {
    this.route.queryParams.subscribe(params => {
      this.userService.UserValues.subscribe(async (data: any) => {
        this.token = params['token'];
        this.subscriptions.push(combineLatest([
          this.SubscriptionService.postSubToken(this.token),
          this.TenantService.getTenantsForUser(data.username)
            ]).subscribe((data: any[]) => {
                //Token received - Post to Auth service to decode and start process
                console.log(data[0]);
                    this.PlanSize = data[0].quantity;
                    this.PlanType = data[0].planName;
                    this.PlanID = data[0].id;

                    var tempArray = [];
                    data[1].forEach((element: any) => {
                      let tenant = {
                        id: '',
                        name: '',
                        url: ''
                      };
                      tenant.name = element.name;
                      tenant.id = element.id;
                      tenant.url = element.url;
                      tempArray.push(tenant);
                    });
                    this.tenants = tempArray;
                    this.tenantsLoaded = true;
                    this.loading = false;
                    
                    this.buildForms();
                }));
            });
      });
  }

  buildForms() {
    this.activatedFormGroup = this.formBuilder.group({
      tenantDropdown: new FormControl(null, Validators.required)
    });
  }


  public activateLicence(){
    //this.loading = !this.loading;

    //check if Tenant is selected
    if (this.activatedFormGroup.controls['tenantDropdown'].value)
    {
      //Make call to subscribe the current Sub to the selected Tennant
      this.SubscriptionService.postActivateSub(this.PlanID, this.activatedFormGroup.controls['tenantDropdown'].value.id).subscribe(data => {
        //Call made
      });
    }
    else
    {
      //prompt missing val
    }

  }

  ngOnDestroy(): void {
    throw new Error('Method not implemented.');
  }
}
